import truncate from "lodash/truncate";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import { ECOption } from "PFCore/helpers/echarts_wrapper";
import { useMemo } from "react";

import { Header, HeaderProps } from "./header";

const getOptions = (
  color: string[],
  data: RadarChartProps["data"],
  indicator: { text: string }[],
  colors: {
    axisName: string;
    axisLine: string;
    splitLine: string;
  },
  splitNumber: number
): ECOption => ({
  color,
  radar: [
    {
      indicator: indicator?.map((item) => ({ ...item, text: truncate(item.text, { length: 12 }) })),
      center: ["50%", "50%"],
      radius: "70%",
      splitNumber,
      shape: "circle",
      axisName: {
        color: colors.axisName,
        fontSize: 10
      },
      axisLine: {
        lineStyle: {
          color: colors.axisLine,
          width: 1.5
        }
      },
      splitLine: {
        lineStyle: {
          color: colors.splitLine,
          width: 1.5
        }
      }
    }
  ],
  series: [
    {
      type: "radar",
      symbol: "none",
      label: {
        fontSize: 14,
        color: "black"
      },
      lineStyle: {
        width: 3
      },
      areaStyle: {
        opacity: 1
      },
      emphasis: {
        lineStyle: {
          width: 4
        }
      },
      data
    }
  ]
});

type RadarChartProps = {
  color: string[];
  indicator: { text: string }[];
  title?: string;
  splitNumber: number;
  data: {
    name: string;
    value: number[];
    areaStyle?: { color: string };
  }[];
} & Pick<HeaderProps, "coverage" | "headerIconName" | "onHeaderIconClick">;

export const RadarChart = ({
  color,
  coverage,
  data,
  indicator,
  splitNumber,
  title,
  headerIconName,
  onHeaderIconClick
}: RadarChartProps) => {
  const { themeVars } = useTheme();
  const options: ECOption = useMemo(
    () =>
      getOptions(
        color,
        data,
        indicator,
        {
          axisName: themeVars["paletteBlue2"],
          axisLine: themeVars["paletteWhite3"],
          splitLine: themeVars["paletteWhite3"]
        },
        splitNumber
      ),
    [color, data, indicator, themeVars, splitNumber]
  );
  const series = data.map((item) => ({ ...item, data: item.value.map((value) => ({ value })) }));

  return (
    <>
      {title && (
        <Header
          title={title}
          series={series}
          coverage={coverage}
          headerIconName={headerIconName}
          onHeaderIconClick={onHeaderIconClick}
        />
      )}
      <EchartsWrapper options={options} height={170} minWidth={264} />
    </>
  );
};
